import React, { useState, useEffect } from "react";
// redux
import { useSelector, useDispatch } from "react-redux";
import { toggleLost } from "../../redux/actions/FlashActions.js";
import { postLost } from "../../redux/actions/LostActions.js";
// react components for routing our app without refresh
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
// @material-ui/icons
import { Close } from "@material-ui/icons";
// core components
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
// other
import { toast } from "react-toastify";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";
import { toastOptions } from "utils.js";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export default function LostModal() {
  const classes = useStyles();

  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const lostModal = useSelector((state) => state.flash.lostModal);
  const [itemName, setItemName] = useState("");
  const [description, setDescription] = useState("");
  const [location, setLocation] = useState("");
  const [lostTimestamp, setLostTimestamp] = useState(Date().toLocaleString());
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (!auth.isAuthenticated && lostModal) {
      toggleLost(dispatch);
      history.push("/users/login");
      toast.warning("Please login first!", toastOptions);
    }
  }, [auth, lostModal, dispatch, history]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (itemName === "" || description === "" || location === "") {
      toast.warning("Please check the required fields!", toastOptions);
      return;
    }
    const formData = new FormData();
    formData.append("itemName", itemName);
    formData.append("description", description);
    formData.append("location", location);
    formData.append("lostTimestamp", lostTimestamp);
    formData.append("image", image);
    postLost(dispatch, history, formData);
  };

  return (
    <Dialog
      classes={{
        root: classes.center,
        paper: classes.modal,
      }}
      open={lostModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => toggleLost(dispatch)}
      aria-labelledby="lost-modal-slide-title"
      aria-describedby="lost-modal-slide-description"
    >
      <form onSubmit={handleSubmit} className={classes.form}>
        <DialogTitle
          id="lost-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <IconButton
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() => toggleLost(dispatch)}
          >
            <Close className={classes.modalClose} />
          </IconButton>
          <h4 className={classes.modalTitle}>Report Lost Item</h4>
        </DialogTitle>
        <DialogContent
          id="lost-modal-slide-description"
          className={classes.modalBody}
        >
          <CustomInput
            labelText="item Name*"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (e) => setItemName(e.target.value),
              type: "text",
            }}
          />
          <CustomInput
            labelText="Short Description*"
            formControlProps={{
              fullWidth: true,
              className: classes.textArea,
            }}
            inputProps={{
              onChange: (e) => setDescription(e.target.value),
              multiline: true,
              rows: 2,
            }}
          />
          <CustomInput
            labelText="Location*"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (e) => setLocation(e.target.value),
              type: "text",
            }}
          />
          <CustomInput
            labelText="Date and Time when Lost"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (e) => setLostTimestamp(e.target.value),
              type: "datetime-local",
            }}
          />
          <CustomInput
            labelText="Item Image (if available)"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              disabled: true,
              endAdornment: (
                <Button round size="sm" color="primary" component="label">
                  Upload File
                  <input
                    type="file"
                    name="image"
                    onChange={(e) => setImage(e.target.files[0])}
                    hidden
                  />
                </Button>
              ),
            }}
          />
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button onClick={() => toggleLost(dispatch)} color="danger" simple>
            Cancel
          </Button>
          <Button type="submit" value="submit" color="success" simple>
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
